import { ReactComponent as Star } from "../../../assets/icons/Star.svg";
import { RateStar } from "./index.styled";

interface ReviewRateProps {
  value: number;
}

/**
 * 리뷰용 별점 컴포넌트 (half 값 처리)
 * @param param0
 * @returns
 */
export const ReviewRate: React.FC<ReviewRateProps> = ({ value }) => {
  return <RateStar disabled allowHalf character={<Star />} value={value} />;
};
